import React from 'react';
import { ReactComponent as SpinnerSvg } from './spinner.svg';
import './style.css';

const Spinner = () => (
  <div style={{ textAlign: 'center', width: '100%' }}>
    <SpinnerSvg className="spinner_loading" />
  </div>
);

export default Spinner;
